/**
 * Inline SVG icons for role navigation sidebar (module IDs + section headers).
 * Strokes inherit `currentColor` for active/link states.
 */

const baseProps = ({ size = 20, className }) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.65,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  className,
  'aria-hidden': true,
});

export const NavSectionBusinessIcon = (props) => (
  <svg {...baseProps(props)}>
    <path d="M4 21V10l4-7h8l4 7v11" />
    <path d="M2 10h20" />
    <path d="M9 21v-4h6v4" />
  </svg>
);

export const NavSectionAdminIcon = (props) => (
  <svg {...baseProps(props)}>
    <path d="M12 21s8-3.94 8-11V7l-8-5-8 5v3c0 7.06 8 11 8 11z" />
  </svg>
);

export const NavIconDashboard = (props) => (
  <svg {...baseProps(props)}>
    <rect x="3" y="3" width="7" height="7" rx="1.25" />
    <rect x="14" y="3" width="7" height="7" rx="1.25" />
    <rect x="3" y="14" width="7" height="7" rx="1.25" />
    <rect x="14" y="14" width="7" height="7" rx="1.25" />
  </svg>
);

export const NavIconCustomers = (props) => (
  <svg {...baseProps(props)}>
    <circle cx="9" cy="8" r="3" />
    <circle cx="17.5" cy="10" r="2.5" />
    <path d="M4 21v-.5a5 5 0 019-2.83M15 21v-.5a4.95 4.95 0 00-8.5-.33" />
  </svg>
);

export const NavIconPricing = (props) => (
  <svg {...baseProps(props)}>
    <path d="M4 10V6a2 2 0 012-2h2.5a2 2 0 011.55.72L20 14.5V21H4v-2" />
    <path d="M20 14.5l-6-6-3.5 5.5L13 19" />
    <circle cx="8" cy="14" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

export const NavIconDiscounts = (props) => (
  <svg {...baseProps(props)}>
    <circle cx="12" cy="12" r="9.5" />
    <path d="M9 15l7-9M14.5 8.5h.01M11.5 15.5h.01" />
  </svg>
);

export const NavIconFinancialManagement = (props) => (
  <svg {...baseProps(props)}>
    <path d="M4 17V7a2 2 0 012-2h12a2 2 0 012 2v10" />
    <path d="M4 17h16" />
    <path d="M8 21h8v-4H8v4zM9 10h4M9 14h7" />
  </svg>
);

export const NavIconSalesReports = (props) => (
  <svg {...baseProps(props)}>
    <path d="M4 21V7h16v14H4z" />
    <path d="M8 15v5M12 11v9M16 17v3" />
  </svg>
);

export const NavIconUtilities = (props) => (
  <svg {...baseProps(props)}>
    <path d="M14.7 6.3a6 6 0 11-8.4 8.4L4 20l5.3-2.3a6 6 0 005.4-8.4z" />
    <path d="M19.4 4.6L22 7.2" />
  </svg>
);

export const NavIconAudit = (props) => (
  <svg {...baseProps(props)}>
    <path d="M9 12h11M9 16h11M13 21H5a2 2 0 01-2-2V7a2 2 0 012-2h5l9 10v11a2 2 0 01-2 2h0" />
    <path d="M9 3v6h5" />
  </svg>
);

export const NavIconFinancialSettings = (props) => (
  <svg {...baseProps(props)}>
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <path d="M6 14h12M18 14h3v-5h-3" />
    <circle cx="8" cy="12" r="2" />
  </svg>
);

export const NavIconIntegrations = (props) => (
  <svg {...baseProps(props)}>
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98M8.59 10.49l6.83-3.98M15.41 17.49l-6.82-3.98" />
  </svg>
);

export const NavIconUserManagement = (props) => (
  <svg {...baseProps(props)}>
    <circle cx="8.5" cy="7.5" r="2.5" />
    <path d="M3 20v-.5a5.5 5.5 0 0111 0v.5" />
    <circle cx="17" cy="8" r="2.25" />
    <path d="M13 20v-.55a7 7 0 019.93-6.93" />
  </svg>
);

export const NavIconSystemSettings = (props) => (
  <svg {...baseProps(props)}>
    <circle cx="12" cy="12" r="2.75" />
    <path d="M12 3v3M12 18v3M4.93 7.93l2.13 2.13M17 13.93l2.13 2.13M3 14h3M18 14h3M7.93 4.93L10.06 7.06M16.93 17L19.06 19.06" />
  </svg>
);

export const NavIconSupport = (props) => (
  <svg {...baseProps(props)}>
    <circle cx="12" cy="12" r="9.5" />
    <path d="M9.3 9.2a2.7 2.7 0 015.4 1c0 1.7-2.7 2.3-2.7 2.9" />
    <path d="M12 16.5h.01" />
  </svg>
);

/** Map sidebar module ids (see AuthenticatedPanel) to icon components — only nav-visible routes */
export const NAV_ITEM_ICONS = {
  dashboard: NavIconDashboard,
  customers: NavIconCustomers,
  pricing: NavIconPricing,
  discounts: NavIconDiscounts,
  'gift-cards': NavIconDiscounts,
  'financial-management': NavIconFinancialManagement,
  'sales-reports': NavIconSalesReports,
  utilities: NavIconUtilities,
  audit: NavIconAudit,
  'financial-settings': NavIconFinancialSettings,
  integrations: NavIconIntegrations,
  'user-management': NavIconUserManagement,
  'system-settings': NavIconSystemSettings,
};
